<template>
  <div class="login-page">
    <!-- 顶部渐变条 -->
    <div class="top-bar"></div>

    <!-- 背景装饰圆 -->
    <div class="bg-decoration bg-decoration-1"></div>
    <div class="bg-decoration bg-decoration-2"></div>
    <div class="bg-decoration bg-decoration-3"></div>

    <div class="login-container">
      <div class="login-card">
        <!-- 卡片头部 - 蓝青渐变 -->
        <div class="card-header">
          <!-- <div class="logo-icon">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 2.18l7 3.12v4.7c0 4.67-3.13 9.07-7 10.2-3.87-1.13-7-5.53-7-10.2V6.3l7-3.12zM11 7v6h2V7h-2zm0 8v2h2v-2h-2z"/>
            </svg>
          </div> -->
          <h1>舆情培训系统</h1>
          <p>后台管理 · 学院端 · 手机答题</p>
        </div>

        <!-- 表单区域 -->
        <div class="card-body">
          <form @submit.prevent="handleLogin">
            <div class="form-group">
              <label>用户名</label>
              <div class="input-wrapper">
                <input v-model="username" type="text" placeholder="请输入用户名" required autocomplete="username">
                <svg class="input-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </div>
            </div>

            <div class="form-group">
              <label>密码</label>
              <div class="input-wrapper">
                <input v-model="password" type="password" placeholder="请输入密码" required autocomplete="current-password">
                <svg class="input-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z"/>
                </svg>
              </div>
            </div>

            <div class="form-options">
              <label class="remember-me">
                <input type="checkbox" v-model="rememberMe"> 记住我
              </label>
              <a href="#" class="forgot-password" @click.prevent>忘记密码？</a>
            </div>

            <button type="submit" class="login-btn" :disabled="loading">
              <span v-if="loading"><span class="spinner"></span>登录中...</span>
              <span v-else>登 录</span>
            </button>
          </form>

          <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>
        </div>

        <!-- 底部信息 -->
        <!-- <div class="card-footer">
          <p>© 2026 舆情培训系统 · 版权所有</p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      rememberMe: false,
      errorMsg: '',
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true
      this.errorMsg = ''
      
      try {
        const response = await axios.post('/api/auth/login', {
          username: this.username,
          password: this.password
        })
        
        if (response.data && response.data.code === 200) {
          const userInfo = response.data.data
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          // 根据角色跳转不同页面
          if (userInfo.role === 'ADMIN') {
            this.$router.push('/cases')
          } else {
            this.$router.push('/academy')
          }
        } else {
          this.errorMsg = response.data?.message || '未知错误'
        }
      } catch (error) {
        console.error('登录失败:', error)
        this.errorMsg = '登录失败：' + (error.response?.data?.message || error.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.login-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  background: #f0f4f8;
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

/* 顶部渐变条 */
.top-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, #3B82F6, #06B6D4, #10B981);
  z-index: 10;
}

/* 背景装饰圆 */
.bg-decoration {
  position: fixed;
  border-radius: 50%;
  opacity: 0.06;
  pointer-events: none;
}

.bg-decoration-1 {
  width: 400px;
  height: 400px;
  background: #3B82F6;
  top: -100px;
  right: -100px;
}

.bg-decoration-2 {
  width: 300px;
  height: 300px;
  background: #06B6D4;
  bottom: -80px;
  left: -80px;
}

.bg-decoration-3 {
  width: 200px;
  height: 200px;
  background: #10B981;
  top: 50%;
  left: 10%;
}

/* 主容器 */
.login-container {
  width: 100%;
  max-width: 440px;
  padding: 20px;
  position: relative;
  z-index: 1;
}

/* 登录卡片 */
.login-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(59, 130, 246, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 卡片头部 - 蓝青渐变 */
.card-header {
  background: linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%);
  padding: 36px 32px 28px;
  text-align: center;
  position: relative;
}

.card-header::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 20px;
  background: #ffffff;
  border-radius: 20px 20px 0 0;
}

/* 盾牌图标 */
.logo-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(8px);
}

.logo-icon svg {
  width: 36px;
  height: 36px;
  fill: #ffffff;
}

.card-header h1 {
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 2px;
}

.card-header p {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  margin-top: 6px;
  letter-spacing: 1px;
}

/* 表单区域 */
.card-body {
  padding: 32px 32px 36px;
}

.form-group {
  margin-bottom: 22px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}

.input-wrapper {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  fill: #94a3b8;
  transition: fill 0.2s;
  pointer-events: none;
}

.form-group input {
  width: 100%;
  height: 48px;
  padding: 0 16px 0 44px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 15px;
  color: #1e293b;
  background: #f8fafc;
  transition: all 0.25s ease;
  outline: none;
}

.form-group input::placeholder {
  color: #94a3b8;
}

.form-group input:focus {
  border-color: #3B82F6;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.input-wrapper:focus-within .input-icon {
  fill: #3B82F6;
}

/* 记住我 & 忘记密码 */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  margin-top: -4px;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #64748b;
  cursor: pointer;
}

.remember-me input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #3B82F6;
  cursor: pointer;
}

.forgot-password {
  font-size: 13px;
  color: #3B82F6;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.forgot-password:hover {
  color: #06B6D4;
}

/* 登录按钮 - 蓝青渐变 */
.login-btn {
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%);
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
  position: relative;
  overflow: hidden;
}

.login-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent);
  transition: left 0.5s;
}

.login-btn:hover::before {
  left: 100%;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(59, 130, 246, 0.4);
}

.login-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* 错误消息 */
.error-msg {
  color: #ef4444;
  font-size: 13px;
  margin-top: 16px;
  text-align: center;
  padding: 12px;
  background: rgba(239, 68, 68, 0.08);
  border-radius: 8px;
  border: 1px solid rgba(239, 68, 68, 0.2);
  animation: shake 0.5s ease-in-out;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

/* 底部信息 */
.card-footer {
  text-align: center;
  padding: 0 32px 28px;
}

.card-footer p {
  font-size: 12px;
  color: #94a3b8;
}

/* 加载动画 */
.spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-right: 8px;
  vertical-align: middle;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
